import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'
import { colors as bsColors } from '@resiliatech/birdsong'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    staticPopupContainer: {
      background: colors.resiliaWhite,
      padding: '40px',
      textAlign: 'center',
      maxWidth: '640px',
      borderRadius: '4px',
      boxShadow: '4px 8px 32px rgba(0, 50, 99, 0.15)',
      margin: '0 auto',
      '& h1': {
        marginBottom: '20px',
        color: bsColors.copy.headerDark,
        paddingRight: ({ withCloseIcon }: { withCloseIcon: boolean }) =>
          withCloseIcon ? '24px' : 'initial',
      },
      color: bsColors.copy.paragraphDark,
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1400,
      width: '100%',
      [theme.breakpoints.up('md')]: {
        '&.withDrawer': {
          left: 'calc(50% + 120px) !important',
        },
      },
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100% - 20px)',
        maxHeight: 'calc(100% - 80px)',
        overflowY: 'auto',
        padding: '20px',
        top: '0',
        zIndex: 1198,
        transform: 'translate(-50%, 60px)',
      },
    },
    backgroundContainer: {
      position: 'fixed',
      left: 0,
      top: 0,
      height: '100vh',
      width: '100vw',
      background: 'hsla(0,0%,0%, .50)',
      zIndex: 1199,
    },
    primaryButton: {
      marginTop: '20px',
      backgroundColor: colors.resiliaBlue,
      color: '#fff',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: colors.darkestBlue,
        color: '#fff',
        boxShadow: 'none',
      },
    },
    secondaryButton: {
      marginTop: 20,
      marginRight: 30,
    },
    closeIcon: {
      position: 'absolute',
      top: '45px',
      right: '45px',
      height: '14px',
      width: '14px',
      [theme.breakpoints.down('sm')]: {
        top: '35px',
        right: '25px',
      },
    },
  })
)

export default useStyles
